<svg
  width="143"
  height="27"
  viewBox="0 0 143 27"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.2979 26.5957C19.1249 26.5957 22.3643 26.5957 24.48 24.48C26.5957 22.3643 26.5957 19.1249 26.5957 13.2979C26.5957 7.47082 26.5957 4.23148 24.48 2.11574C22.3643 -4.09092e-07 19.1249 0 13.2979 0C7.47082 0 4.23148 -4.09092e-07 2.11574 2.11574C-4.09092e-07 4.23148 0 7.47082 0 13.2979C0 19.1249 -4.09092e-07 22.3643 2.11574 24.48C4.23148 26.5957 7.47082 26.5957 13.2979 26.5957Z"
    fill="currentColor"
  />
  <path
    d="M6.35663 11.3081V13.2919L14.0369 13.3076L14.4901 11.3238L6.35663 11.3081Z"
    fill="white"
  />
  <path
    d="M6.35663 7.33276V9.31651L14.9432 9.33226L15.02 8.98589C15.212 8.15145 14.5976 7.34851 13.7604 7.34851L6.35663 7.33276Z"
    fill="white"
  />
  <path
    d="M13.5738 15.2915L14.0269 13.3077L18.8885 13.3156L18.1743 15.2994L13.5738 15.2915Z"
    fill="white"
  />
  <path
    d="M14.4835 11.3235L14.9443 9.33978L21.872 9.31616L21.0579 11.292L14.4835 11.3235Z"
    fill="white"
  />
  <path
    d="M6.35663 15.2739V17.2577L13.123 17.2734L13.5761 15.2897L6.35663 15.2739Z"
    fill="white"
  />
  <path
    d="M16.0076 19.2652H14.6021C13.5883 19.2652 12.851 18.2733 13.1122 17.2736H16.7833L16.0076 19.2652Z"
    fill="white"
  />
  <path
    d="M48.3079 21.019H51.7627L52.0977 18.9671H52.7258C53.2283 20.4746 54.5893 21.2284 55.9922 21.2284C58.9026 21.2284 60.6823 19.344 60.6823 15.3239C60.6823 11.7853 59.2166 9.4193 56.0759 9.4193C54.5684 9.4193 53.2283 10.3196 52.7258 11.6597H52.0977L52.307 8.51896V5.31543H48.3079V21.019ZM52.307 15.6798V14.9888C52.307 13.5232 53.1236 12.6228 54.5474 12.6228C55.7828 12.6228 56.6203 13.1672 56.6203 14.5701V16.0986C56.6203 17.2502 56.055 18.0249 54.5684 18.0249C53.0818 18.0249 52.307 17.1245 52.307 15.6798Z"
    fill="currentColor"
  />
  <path
    d="M61.7285 15.3448C61.7285 18.8833 64.0527 21.2284 67.5912 21.2284C70.5226 21.2284 72.6792 19.679 72.9723 17.292H69.1616C69.0569 17.9411 68.3869 18.318 67.4656 18.318C66.5234 18.318 65.7487 17.7317 65.7487 16.8523V16.2661H72.8467C72.9723 15.8264 73.0142 15.2192 73.0142 14.6329C73.0142 11.2409 70.5644 9.4193 67.4656 9.4193C64.2411 9.4193 61.7285 11.555 61.7285 15.3448ZM65.7487 13.8791V13.6488C65.7487 12.895 66.4606 12.3506 67.4237 12.3506C68.3869 12.3506 69.015 12.895 69.015 13.6488V13.8791H65.7487Z"
    fill="currentColor"
  />
  <path
    d="M82.3367 9.56587C81.0595 9.56587 80.0754 10.2987 79.7613 12.1203H79.1332L78.6516 9.62868H73.3961V12.8322H75.134V21.019H79.1332V16.3708C79.1332 13.9838 80.6198 13.3138 82.3158 13.3138C82.5461 13.3138 82.7764 13.3347 83.0277 13.3557V9.62868C82.8602 9.58681 82.588 9.56587 82.3367 9.56587Z"
    fill="currentColor"
  />
  <path
    d="M84.0908 9.62868V24.5157H88.09V22.1287L87.8806 18.988H88.5087C89.0112 20.3281 90.3513 21.2284 91.8588 21.2284C94.9995 21.2284 96.4652 18.8624 96.4652 15.3239C96.4652 11.3037 94.6855 9.4193 91.7751 9.4193C90.3722 9.4193 89.0112 10.1731 88.5087 11.6806H87.8806L87.5456 9.62868H84.0908ZM88.09 14.9679C88.09 13.5232 88.8647 12.6228 90.3513 12.6228C91.8379 12.6228 92.4032 13.3975 92.4032 14.5491V16.0776C92.4032 17.4805 91.5657 18.0249 90.3303 18.0249C88.9066 18.0249 88.09 17.1245 88.09 15.6589V14.9679Z"
    fill="currentColor"
  />
  <path
    d="M101.432 17.9202V5.31543H97.4536V17.983C97.4536 19.8046 98.1864 21.019 100.49 21.019H104.028V17.9202H101.432Z"
    fill="currentColor"
  />
  <path
    d="M104.763 17.8155C104.763 19.9093 106.291 21.2284 108.636 21.2284C110.584 21.2284 111.945 20.3281 112.384 18.988H112.95V21.019H117.137V18.0877H115.693V13.5441C115.693 11.0734 114.269 9.4193 110.626 9.4193C107.276 9.4193 105.328 10.864 105.454 13.6697H109.118C109.055 12.7275 109.621 12.4135 110.437 12.4135C111.212 12.4135 111.714 12.7275 111.714 13.5232V14.3188L108.532 14.5282C106.291 14.6748 104.763 15.7217 104.763 17.8155ZM108.783 17.2711C108.783 16.8314 109.097 16.4126 109.809 16.3708L111.714 16.2451V17.5642C111.4 18.0458 110.772 18.3599 109.997 18.3599C109.16 18.3599 108.783 18.0039 108.783 17.5224V17.2711Z"
    fill="currentColor"
  />
  <path
    d="M118.351 21.019H122.35V14.926C122.35 13.586 123.02 12.6438 124.36 12.6438C125.491 12.6438 126.119 13.2929 126.119 14.6957V21.019H130.139V13.2929C130.139 10.9687 128.862 9.4193 126.579 9.4193C124.821 9.4193 123.564 10.2359 122.978 11.6597H122.35L121.868 9.62868H118.351V21.019Z"
    fill="currentColor"
  />
  <path
    d="M131.424 15.3448C131.424 18.8833 133.748 21.2284 137.287 21.2284C140.218 21.2284 142.375 19.679 142.668 17.292H138.857C138.752 17.9411 138.082 18.318 137.161 18.318C136.219 18.318 135.444 17.7317 135.444 16.8523V16.2661H142.542C142.668 15.8264 142.71 15.2192 142.71 14.6329C142.71 11.2409 140.26 9.4193 137.161 9.4193C133.936 9.4193 131.424 11.555 131.424 15.3448ZM135.444 13.8791V13.6488C135.444 12.895 136.156 12.3506 137.119 12.3506C138.082 12.3506 138.71 12.895 138.71 13.6488V13.8791H135.444Z"
    fill="currentColor"
  />
  <path
    d="M39.0709 9.62983H46.9636V21.019H42.9457V12.8298H39.0709V21.019H35.053V12.8298H32.9776V9.62983H35.053V8.64835C35.053 8.38254 35.0564 8.18829 35.0632 8.0656C35.07 7.9361 35.0905 7.77593 35.1246 7.58509C35.1655 7.39425 35.2268 7.18977 35.3086 6.97167C35.7107 5.86751 36.7365 5.31543 38.3859 5.31543H41.6462V8.41321H39.0709V9.62983ZM42.9661 8.41321V5.31543H46.9636V8.41321H42.9661Z"
    fill="currentColor"
  />
</svg>
